import { Component, OnInit, Input } from '@angular/core';
import { DonneReferenceService } from '../../services/donne-reference.service';

@Component({
  selector: 'app-card-contact',
  templateUrl: './card-contact.component.html',
  styleUrls: ['./card-contact.component.scss'],
  standalone: false
})
export class CardContactComponent implements OnInit {
  @Input() aBordure = false;

  telephoneSansFrais: string;
  telephoneMontreal: string;

  constructor(private readonly _donneeReferencesService: DonneReferenceService) {}

  ngOnInit() {
    const ref = this._donneeReferencesService.numerosDemandeSupport;
    this.telephoneSansFrais = ref.sansFrais;
    this.telephoneMontreal = ref.montreal;
  }
}
